import React from 'react'

import { Actions, SimpleCacheReducer, initialState } from './reducer'

const useSimpleCache = () => {
  const [{ loading, cache }, dispatch] = React.useReducer(
    SimpleCacheReducer,
    initialState
  )

  const startLoad = React.useCallback(id => {
    dispatch({ type: Actions.START_LOAD, id })
  }, [])

  const endLoad = React.useCallback((id, data) => {
    dispatch({ type: Actions.END_LOAD, id, data })
  }, [])

  const isLoading = React.useCallback(
    id => {
      return loading.includes(id)
    },
    [loading]
  )

  const isCached = React.useCallback(
    id => {
      return id in cache
    },
    [cache]
  )

  return { cache, startLoad, endLoad, isLoading, isCached }
}

export default useSimpleCache
